import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import styles from './Card.module.css'

type CardProps = PropsWithChildren<{ title: string; highlighted?: boolean }>

export const Card = ({ title, children, highlighted = false }: CardProps) => (
  <div className={clsx(styles.card, highlighted ? styles.highlight : null)}>
    <div className={styles.cardTitle}>{title}</div>
    <div className={styles.cardContents}>{children}</div>
  </div>
)
